import { ReactElement } from 'react';
import styles from './results.module.scss';
import Select, { SingleValue, StylesConfig } from 'react-select';
import { useRouter } from 'next/router';

interface ResultsRaceSelectorProps {
    options: { label: string; value: string }[];
    maxYear: number | undefined;
}

export const ResultsYearSelector = (props: ResultsRaceSelectorProps): ReactElement => {
    const { options, maxYear } = props;
    const { push, query, pathname } = useRouter();

    const customStyles: StylesConfig = {
        menu: (provided) => ({
            ...provided,
            margin: 0,
        }),
        dropdownIndicator: () => ({}),
        indicatorSeparator: (provided) => ({
            ...provided,
        }),
        control: (base) => ({
            ...base,
            height: 60,
            padding: '0 10px',
            borderRadius: 0,
            boxShadow: '3px 3px 11px rgba(0, 0, 0, 0.1)',
        }),
        option: (base, state) => ({
            ...base,
            cursor: 'pointer',
            height: 60,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: state.isSelected ? 'var(--utmb-color-primary)' : 'var(--utmb-color-whhite)',
        }),
        menuList: (provided) => ({
            ...provided,
            paddingTop: 0,
        }),
    };

    const handleChange = (yearData: SingleValue<{ label: string; value: string }>) => {
        if (yearData?.value) {
            const year = yearData.value;
            delete query.raceUri;
            delete query.page;
            push({ pathname, query: { ...query, year } }, undefined, { shallow: true }).then();
        }
    };
    const selectedOption = options.find((value) => (query.year ? value.value === query.year.toString() : value.value === maxYear?.toString()));

    return (
        <div className={styles.selectorYearContainer}>
            <Select
                instanceId="year-selector"
                isSearchable={false}
                menuShouldScrollIntoView={true}
                value={selectedOption}
                onChange={handleChange}
                options={options}
                styles={customStyles as never}
            />
        </div>
    );
};
